import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full mx-auto" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "overflow-x-auto generic-table-div",
  style: {"scrollbar-width":"thin"}
}
const _hoisted_4 = { class: "min-w-full divide-y divide-gray-200 mx-auto" }
const _hoisted_5 = { class: "bg-gray-50" }
const _hoisted_6 = {
  key: 0,
  scope: "col",
  class: "px-6 py-3 text-start"
}
const _hoisted_7 = { class: "flex items-center gap-x-2" }
const _hoisted_8 = { class: "text-xs font-semibold uppercase tracking-wide text-gray-800 text-nowrap" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "size-px whitespace-nowrap"
}
const _hoisted_11 = { class: "block px-6 py-1" }
const _hoisted_12 = { class: "block px-6 py-[4px]" }
const _hoisted_13 = ["disabled", "checked"]
const _hoisted_14 = {
  key: 1,
  class: "font-mono text-sm text-blue-600"
}
const _hoisted_15 = {
  key: 0,
  class: "px-6 py-4 flex justify-between items-center border-t border-gray-200"
}
const _hoisted_16 = { class: "text-sm text-gray-700" }
const _hoisted_17 = { class: "font-medium" }
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = { class: "font-medium" }
const _hoisted_20 = { class: "inline-flex gap-x-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left text-lg text-gray-800" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right text-lg text-gray-800" }, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "text-center p-5"
}
const _hoisted_24 = { class: "flex w-full justify-center" }
const _hoisted_25 = { class: "text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl" }
const _hoisted_26 = { class: "mt-1 text-base leading-7 text-gray-600" }


import Button from 'primevue/button';
import 'primeicons/primeicons.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: ['data', 'columns', 'totalCount', 'active', 'routeName', 'hasTableRoute', 'offset', 'limit', 'isEditMode', 'message'],
  emits: ['nextPage', 'prevPage', 'rowClicked', 'captainChange', 'keeperChange', 'removeItem'],
  setup(__props, { emit: __emit }) {

const emit = __emit


/**
 * Function that takes a string index with dot notation and returns the value from object 
 * @param o Object to be indexed
 * @param s string represting index
 */
function byString(o: { [x: string]: any; }, s: string) {
    const properties = s.split(".");
    for (let i = 0; i < properties.length; i++) {
        if (!o) return null;
        o = o[properties[i]];
    }
    return o;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.totalCount != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("thead", _hoisted_5, [
                _createElementVNode("tr", null, [
                  (__props.isEditMode)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_6))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (header, key) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: key,
                      scope: "col",
                      class: "px-6 py-3 text-start"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(header.name), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.isArray(__props.data) ? __props.data : [__props.data], (item, index) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  key: index,
                  class: "divide-y divide-gray-200"
                }, [
                  _createElementVNode("tr", {
                    class: "hover:bg-gray-50 bg-white",
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => {_ctx.$emit('rowClicked', item, index);}
                  }, [
                    (__props.isEditMode)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, [
                            _createVNode(_unref(Button), {
                              icon: "pi pi-trash text-red-800",
                              class: "hover:bg-gray-200",
                              onClick: ($event: any) => (_ctx.$emit('removeItem', item))
                            }, null, 8, ["onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (header) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: header.key,
                        class: "size-px whitespace-nowrap"
                      }, [
                        _createElementVNode("span", _hoisted_12, [
                          (typeof byString(item, header.key) == 'boolean')
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "checkbox",
                                disabled: !__props.isEditMode,
                                checked: byString(item, header.key)
                              }, null, 8, _hoisted_13))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(byString(item, header.key) == undefined || byString(item,
                                                    header.key)?.length == 0 ? '-' : byString(item, header.key)?.toString()), 1))
                        ])
                      ]))
                    }), 128))
                  ], 8, _hoisted_9)
                ]))
              }), 128))
            ])
          ]),
          (__props.totalCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_16, [
                      _createTextVNode(" Showing " + _toDisplayString(' ') + " "),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(__props.offset + 1), 1),
                      _createTextVNode(" " + _toDisplayString(' ') + " to " + _toDisplayString(' ') + " "),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(__props.offset + __props.data.length), 1),
                      _createTextVNode(" " + _toDisplayString(' ') + " of " + _toDisplayString(' ') + " "),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(__props.totalCount), 1),
                      _createTextVNode(" " + _toDisplayString(' ') + " results ")
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_20, [
                    (__props.offset != 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prevPage'))),
                          class: "py-1 px-2 inline-flex items-center gap-x-2 text-m font-medium rounded-lg h-8 border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
                        }, [
                          _hoisted_21,
                          _createTextVNode(" Prev ")
                        ]))
                      : _createCommentVNode("", true),
                    (__props.totalCount > __props.offset + __props.limit)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('nextPage'))),
                          class: "py-1 px-2 inline-flex items-center gap-x-2 text-m font-medium rounded-lg h-8 border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
                        }, [
                          _createTextVNode(" Next "),
                          _hoisted_22
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("h1", _hoisted_25, _toDisplayString(__props.message ? __props.message.title : 'No results'), 1)
          ]),
          _createElementVNode("p", _hoisted_26, _toDisplayString(__props.message ? __props.message.paragraph : 'Sorry, we cannot find any results matching the parameters'), 1)
        ]))
  ]))
}
}

})